<div class="position cell">
    <span class="title">POS</span>
</div>
<div *ngFor="let field of fields" [ngSwitch]="field" [ngClass]="[field, 'cell']">
    <span class="title" *ngSwitchCase="'number'">NO</span>
    <span class="title" *ngSwitchCase="'name'">NAME</span>
    <span class="title" *ngSwitchCase="'code'">NAME</span>
    <span class="title" *ngSwitchCase="'time'">TIME</span>
    <span class="title" *ngSwitchCase="'lastlap'">LAST LAP</span>
    <span class="title" *ngSwitchCase="'bestlap'">BEST LAP</span>
    <span class="title" *ngSwitchCase="'sector1'">S1</span>
    <span class="title" *ngSwitchCase="'sector2'">S2</span>
    <span class="title" *ngSwitchCase="'sector3'">S3</span>
    <span class="title" *ngSwitchCase="'gap'">GAP</span>
    <span class="title" *ngSwitchCase="'int'">INT</span>
    <span class="title" *ngSwitchCase="'laps'">LAPS</span>
    <span class="title" *ngSwitchCase="'pits'">PITS</span>
    <span class="title" *ngSwitchCase="'fuel'">FUEL</span>
    <span class="title" *ngSwitchCase="'status'"></span>
</div>
